import { Box, SxProps, Typography } from '@mui/material';

import { Maybe } from 'graphql/jsutils/Maybe';
import Resource from '../Resource/Resource';
import { Resource as ResourceType } from '@/generated/contentfulTypes';
import { styledStepTitle } from './StepTitle.styled';

interface StepTitleProps {
  title?: Maybe<ResourceType>;
  subtitle?: Maybe<ResourceType>;
  sx?: SxProps;
  variant?: 'h3' | 'h5';
}

export default function StepTitle({
  title,
  subtitle,
  sx,
  variant = 'h5',
}: StepTitleProps) {
  return (
    <Box sx={sx}>
      {title && (
        <Typography variant={variant} sx={styledStepTitle}>
          <Resource {...title} />
        </Typography>
      )}
      {subtitle && (
        <Typography variant="body4">
          <Resource {...subtitle} />
        </Typography>
      )}
    </Box>
  );
}
